import React, { Component } from 'react';
import { Button, Select } from 'antd';
import { StatisticsList } from '../../../constants';

const { Option } = Select;

class Filter extends Component {
    search = () => {
        this.props.search();
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            default:
                searchParams[key] = value;
                onChange(searchParams);
                break;
        }
    }

    render () {
        const { searchParams } = this.props;

        const statisticsOption = StatisticsList.map(i => <Option key={i.value}>{i.label}</Option>);
        return (
            <div style={{ marginBottom: 16 }}>
                <div className="search-bar">
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">统计内容</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 80}}
                            allowClear={false}
                            value={searchParams.type}
                            onChange={value => this.handleChange(value, 'type')}
                        >
                            {statisticsOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>统计</Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/components/ChartFilter/index.js